<template>
  <div class="privacy-page">
    <bert-loading 
      v-if="isLoading" 
      :fullscreen="true" 
      size="lg" 
      text="Loading Kebijakan Privasi..."
    />

    <div v-else class="page-content">
      <AppHeader />

      <section class="privacy-section">
        <div class="section-container">
          <div class="privacy-header">
            <div class="privacy-icon" @click="goBack">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                <circle cx="20" cy="20" r="20" fill="var(--yellow-main)"/>
                <path d="M24 12L16 20L24 28" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h1 class="privacy-title">Kebijakan Privasi</h1>
          </div>
          
          <div class="privacy-content">
            <div 
              v-for="section in privacySections" 
              :key="section.id" 
              class="privacy-section-item"
            >
              <h2 class="section-heading">
                <span class="bullet">●</span>
                {{ section.title }}
              </h2>
              
              <div class="formatted-text" v-html="section.content"></div>
            </div>
          </div>
        </div>
      </section>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import BertLoading from './ui/Loading.vue'
import Header from './layout/Header.vue'
import Footer from './layout/Footer.vue'

export default {
  name: 'KebijakanPrivasi',
  components: {
    BertLoading,
    AppHeader: Header,
    AppFooter: Footer
  },
  data() {
    return {
      isLoading: false,
      privacySections: [
        {
          id: 1,
          title: 'Pengenalan',
          content: `Selamat datang di bertpoints.com. Kami menyediakan sebuah pengunjung yang akan menggunakan situs ini membaca dan memahami Kebijakan Privasi yang tercantum di sini. Di bertpoints.com, salah satu prioritas utama kami adalah privasi pengunjung kami. Kebijakan Privasi ini berisi jenis informasi yang dikumpulkan dan dicatat oleh bertpoints.com dan bagaimana kami menggunakannya.`
        },
        {
          id: 2,
          title: 'Koleksi Informasi',
          content: `Kami mengumpulkan informasi pribadi Anda ketika dijadikan secara sukarela saat mendaftar menjadi member bertpoints.com, serta menggunakan pengalaman bertpoints.com, kami mungkin memerlukan Anda untuk memberikan informasi pribadi tertentu, termasuk namun tidak terbatas pada nama, nomor telepon, dan alamat pos Anda. Informasi yang kami kumpulkan akan digunakan untuk menghubungi atau mengidentifikasi Anda.`
        },
        {
          id: 3,
          title: 'Komitmen untuk Keamanan Data',
          content: `Informasi pribadi Anda akan disimpan secara aman & tidak disebarluaskan kepada pihak lain. Hanya karyawan BERT's yang dapat memiliki akses ke informasi ini. Anda juga memiliki hak untuk meminta penghapusan data apabila sudah tidak ingin terlibat dalam kegiatan di dalam bertpoints.com.`
        },
        {
          id: 4,
          title: 'Permintaan Penghapusan Data',
          content: `Member Bert Points dapat mengajukan permintaan penghapusan data di bertpoints.com dengan menghubungi Care Center kami dengan melampirkan:
          <ol>
            <li>Copy identitas (KTP/SIM) sesuai yang digunakan saat mendaftar di bertpoints.com</li>
            <li>Nomor handphone yang digunakan untuk situs bertpoints.com</li>
            <li>Alamat email aktif</li>
            <li>Alasan permintaan penghapusan data</li>
          </ol>
          Jika member Bert Points mengajukan permintaan penghapusan data, maka mereka otomatis menyetujui bahwa Reward Points dan atau Award Points yang tersimpan di bertpoints.com akan hangus.`
        },
        {
          id: 5,
          title: 'Kontak Informasi',
          content: `Jika Anda memiliki pertanyaan tambahan atau memerlukan informasi lebih lanjut tentang Kebijakan Privasi kami, jangan ragu untuk menghubungi kami.
          <br><br>
          <div class="contact-box">
            <strong>Bert Points Care Center:</strong><br>
            Tel: +62 878-3175-1536
          </div>`
        }
      ]
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },
    loading() {
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    }
  },
  mounted() {
    this.loading()
  }
}
</script>

<style scoped>
.privacy-page {
  min-height: 100vh;
  background: #F5F5F5;
}

.page-content {
  width: 100%;
}

/* Privacy Section */
.privacy-section {
  padding: var(--space-20) 0;
  background: white;
}

.section-container {
  max-width: 800px;
  margin: 0 auto;
  padding: var(--space-12);
  border-radius: var(--radius-lg);
  border: 1px solid var(--neutral-200);
  background: white;
}

.privacy-header {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  margin-bottom: var(--space-12);
  border-bottom: 1px solid var(--neutral-200);
  padding-bottom: var(--space-8);
}

.privacy-icon {
  flex-shrink: 0;
  cursor: pointer;
  transition: all var(--transition-base);
}

.privacy-icon:hover {
  transform: scale(1.05);
  opacity: 0.8;
}

.privacy-title {
  font-size: var(--text-4xl);
  font-weight: var(--font-bold);
  color: var(--text-dark);
  margin: 0;
}

.privacy-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
}

.privacy-section-item {
  background: white;
}

.section-heading {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  font-size: var(--text-xl);
  font-weight: var(--font-bold);
  color: var(--text-dark);
  margin: 0 0 var(--space-4) 0;
}

.bullet {
  color: var(--text-dark);
  font-size: var(--text-lg);
}

/* --- FORMATTED TEXT STYLES (Matches FAQ Page) --- */
.formatted-text {
  color: var(--text-dark-grey);
  line-height: 1.6;
  font-size: var(--text-base);
}

/* Deep Selectors for v-html content */
.formatted-text >>> p {
  margin-bottom: var(--space-4);
}

.formatted-text >>> strong, 
.formatted-text >>> b {
  font-weight: 700;
  color: var(--text-dark);
}

/* List Styling */
.formatted-text >>> ol, 
.formatted-text >>> ul {
  margin: var(--space-4) 0;
  padding-left: var(--space-6);
}

.formatted-text >>> li {
  margin-bottom: var(--space-2);
  padding-left: var(--space-1);
}

/* Contact Box Styling specific for ID 5 */
.formatted-text >>> .contact-box {
  background: var(--neutral-50);
  padding: var(--space-4);
  border-radius: var(--radius-md);
  border: 1px solid var(--neutral-200);
  display: inline-block;
  min-width: 250px;
}

.formatted-text >>> br {
  display: block;
  margin-bottom: 4px;
  content: "";
}

/* Responsive Design */
@media (max-width: 768px) {
  .section-container {
    padding: var(--space-6) var(--space-4);
    max-width: 100%;
    border: none;
  }
  
  .privacy-header {
    margin-bottom: var(--space-8);
    gap: var(--space-3);
    padding-bottom: var(--space-6);
  }
  
  .privacy-title {
    font-size: var(--text-2xl);
  }
  
  .privacy-content {
    gap: var(--space-8);
  }

  .privacy-section {
    padding: var(--space-4) 0;
  }
  
  .section-heading {
    font-size: var(--text-lg);
    gap: var(--space-2);
    margin-bottom: var(--space-3);
  }
  
  .bullet {
    font-size: var(--text-base);
  }
  
  .formatted-text {
    font-size: var(--text-sm);
    line-height: 1.5;
  }
  
  .formatted-text >>> ol {
    padding-left: var(--space-4);
  }
}
</style>